"use client";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

function ColumnChart({
  data,
  serieName,
  yAxisTitle = "Documentos",
  xAxisTitle = "",
}) {
  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    series: [
      {
        name: serieName,
        data: Object.values(data),
      },
    ],
    xAxis: {
      categories: Object.keys(data),
      crosshair: true,
      accessibility: {
        description: "Años",
      },
      title: {
        text: xAxisTitle,
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: yAxisTitle,
      },
    },
  };
  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
export default ColumnChart;
